const SelectReactHookForm2 = ({reg, handleChange, opciones, valor})=> {
    const hc = handleChange? handleChange: (e)=>{}
    console.log("srhf2 "+reg.name+ " valor" + valor)
    console.log(reg.ref)
    return (
        <select  {...reg} 
        onChange={(e) => {
            console.log("onchange de srhf2 " + reg.name)
            console.log(e)
            reg.onChange(e);
            hc(e);
        }}
        value={valor}
        >{
        opciones.map((o, index) => {
            let key = o.codigo
        
            return (
              <option value={o.codigo} key={key}>
                  {o.nombre}
              </option>
            );
        })
        }</select>
    )
}

export default SelectReactHookForm2;